"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapSidebar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var mobx_react_1 = require("mobx-react");
var If_1 = require("../../hoc/If");
var Icon_1 = require("../../ui/Icon");
var IconSymbols_1 = require("../../generated/IconSymbols");
var Heatmap_Enums_1 = require("./Heatmap_Enums");
var titleParagraphStyle = function (sideBarItem) {
    return {
        paddingLeft: sideBarItem.depth * 15
    };
};
var isTotalsClass = function (key) {
    var text = "";
    if (key === Heatmap_Enums_1.Rows.Totals)
        text = "heatmap__sidebar-row--totals";
    return text;
};
var isOddRowClassName = function (index) {
    var className = "";
    if (index % 2 !== 0)
        className = "heatmap__sidebar-row--odd";
    return className;
};
var sidebarRowClass = function (key, index) {
    return "heatmap__sidebar-row \n    ".concat(isTotalsClass(key), " \n    ").concat(isOddRowClassName(index));
};
var hasParent = function (model) {
    return model.parentId > 0;
};
var isTotalsRow = function (uniqueKey) {
    return uniqueKey === Heatmap_Enums_1.Rows.Totals;
};
var isTotalsRowAndHasParent = function (model, uniqueKey) {
    return isTotalsRow(uniqueKey) && hasParent(model);
};
var ChildrenIndicator = (0, mobx_react_1.observer)(function (_a) {
    var data = _a.data;
    return ((0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: data.hasChildren }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "d-inline-block heatmap__sidebar-title--chevron" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: IconSymbols_1.IconSymbols.ChevronRight, className: "ml-2" }) })) })));
});
var DrillUpIndicator = (0, mobx_react_1.observer)(function (_a) {
    var uniqueKey = _a.uniqueKey, model = _a.model;
    return ((0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: hasParent(model) && isTotalsRow(uniqueKey) }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "d-inline-block heatmap__sidebar-title--chevron" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: IconSymbols_1.IconSymbols.ChevronLeft, className: "m-0" }) })) })));
});
var TotalsLabel = (0, mobx_react_1.observer)(function (_a) {
    var model = _a.model, sidebarItem = _a.sidebarItem, index = _a.index;
    var uniqueKey = sidebarItem.rowKey;
    var label = sidebarItem.label;
    if (uniqueKey == Heatmap_Enums_1.Rows.Totals) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: sidebarRowClass(uniqueKey, index) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap__sidebar-totals px-3" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "heatmap__sidebar-totals--flex-container" }, { children: [(0, jsx_runtime_1.jsx)(If_1.IF, __assign({ condition: uniqueKey !== undefined }, { children: (0, jsx_runtime_1.jsx)(DrillUpIndicator, { className: "heatmap__sidebar-total--drill-up", uniqueKey: sidebarItem.rowKey, model: model }) })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-truncate heatmap__sidebar-title-p mb-0", style: titleParagraphStyle(sidebarItem) }, { children: label }))] })) })) })));
    }
    return null;
});
var Label = (0, mobx_react_1.observer)(function (_a) {
    var model = _a.model, sidebarItem = _a.sidebarItem, index = _a.index;
    var uniqueKey = sidebarItem.rowKey;
    var label = sidebarItem.label;
    if (uniqueKey !== Heatmap_Enums_1.Rows.Totals) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: sidebarRowClass(uniqueKey, index) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap__sidebar-title px-3" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "heatmap__sidebar-title--flex-container ".concat(uniqueKey !== Heatmap_Enums_1.Rows.Parent && model.parentId != 0 ? "pl-5" : "") }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: "text-truncate heatmap__sidebar-title-p mb-0 ".concat(uniqueKey === Heatmap_Enums_1.Rows.Parent ? "font-weight-bold" : ""), style: titleParagraphStyle(sidebarItem) }, { children: [uniqueKey !== Heatmap_Enums_1.Rows.Parent && model.parentId != 0 ? "- " : "", label] })), (0, jsx_runtime_1.jsx)(ChildrenIndicator, { data: sidebarItem })] })) })) })));
    }
    return null;
});
var RowLabels = (0, mobx_react_1.observer)(function (_a) {
    var model = _a.model;
    var sidebarItems = model.sidebarItems;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: sidebarItems.map(function (e, i) {
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: isTotalsRowAndHasParent(model, e.rowKey)
                    ? function () {
                        model.onRowClick();
                    }
                    : e.hasChildren
                        ? function () {
                            model.onRowClick(e.rowId);
                        }
                        : null }, { children: [(0, jsx_runtime_1.jsx)(TotalsLabel, { model: model, sidebarItem: e, index: i }, "sidebar-".concat(i)), (0, jsx_runtime_1.jsx)(Label, { model: model, sidebarItem: e, index: i }, "sidebar-k-".concat(i))] })));
        }) }));
});
var HeatmapSidebar = (0, mobx_react_1.observer)(function (_a) {
    var model = _a.model;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "heatmap__sidebar-content" }, { children: (0, jsx_runtime_1.jsx)(RowLabels, { model: model }) })));
});
exports.HeatmapSidebar = HeatmapSidebar;
